module.exports = __webpack_public_path__ + "static/10-9ea2cc9f04d1c68d451535607a56996b.jpg";